import { useRecoilValue, useSetRecoilState } from "recoil";
import { mobileViewState } from "../../recoil/view/viewMode";
import { TaskInboxWithResizable } from "./TaskInboxWithResizable";
import { RightMainContents } from "../RightMainContents";
import MobileToolbar from "./MobileToolbar";
import { Flex } from "@chakra-ui/react";
import { pxToRem } from "../../utils/styles/size";
import { useEffect } from "react";
import { CalendarViewType } from "../../constants";
import { calendarViewState } from "../../recoil/calendar/calendarState";
import { MOBILE_VIEW_TYPE } from "../../types/main";

const MobileMainView = ({
  hasBlocksSynchronizedWithGoogle,
}: {
  hasBlocksSynchronizedWithGoogle: boolean;
}) => {
  const setCalendarView = useSetRecoilState(calendarViewState);

  useEffect(() => {
    setCalendarView(CalendarViewType.DAY.type);
  }, [setCalendarView]);

  return (
    <Flex
      flex={1}
      bg="#0C0D0D"
      h="100%"
      p={pxToRem(7)}
      gap={2}
      flexDir={"column"}
      width={"100%"}
      height={"100%"}
    >
      <TaskInboxWithResizable hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
      <RightMainContents hasBlocksSynchronizedWithGoogle={hasBlocksSynchronizedWithGoogle} />
      <MobileToolbar />
    </Flex>
  );
};

export default MobileMainView;
